import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthProvider';

const Wrap = styled.main`
  min-height: 100vh;
  display: grid;
  place-items: center;
  padding: 24px;
  background: radial-gradient(90% 80% at 50% 0%, rgba(224, 161, 94, 0.16), transparent 65%),
    linear-gradient(180deg, #0a1024 0%, #040817 100%);
`;

const Card = styled.section`
  width: min(560px, 100%);
  border-radius: 16px;
  border: 1px solid rgba(224, 161, 94, 0.45);
  background: rgba(8, 13, 28, 0.88);
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.45);
  padding: 24px;
  color: #f3f4f6;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
`;

const Icon = styled.img`
  width: 30px;
  height: 30px;
  object-fit: contain;
`;

const Title = styled.h1`
  margin: 0;
  font-size: clamp(1.4rem, 2.2vw, 1.8rem);
  font-weight: 900;
  color: #e0a15e;
`;

const Body = styled.p`
  margin: 0;
  color: rgba(243, 244, 246, 0.88);
  line-height: 1.55;
  font-size: 0.98rem;
`;

const Actions = styled.div`
  margin-top: 18px;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
`;

const Btn = styled.button`
  border-radius: 10px;
  min-height: 38px;
  border: 1px solid rgba(243, 244, 246, 0.24);
  background: rgba(15, 23, 42, 0.7);
  color: #f3f4f6;
  padding: 0 14px;
  font-size: 0.82rem;
  font-weight: 800;
  cursor: pointer;
`;

export default function AccountLockedPage() {
  const navigate = useNavigate();
  const { banReason } = useAuth();
  const reason = banReason?.trim() || 'Your account has been locked and access is disabled.';

  return (
    <Wrap>
      <Card>
        <Header>
          <Icon src="/images/xOut.png" alt="" aria-hidden />
          <Title>Account Locked</Title>
        </Header>
        <Body>{reason} If you believe this is an error, contact an administrator for review and reactivation.</Body>
        <Actions>
          <Btn type="button" onClick={() => navigate('/', { replace: true })}>
            Return to Home
          </Btn>
        </Actions>
      </Card>
    </Wrap>
  );
}
